module.exports = __webpack_public_path__ + "static/dairyFree-2247e00a857f61ed6ab0467070a0de30.png";